export const formatMetrics = (startTime, response) => ({
    duration: Date.now() - startTime,
    status: response.status,
    response,
});
//# sourceMappingURL=metrics.js.map